module.exports = __webpack_public_path__ + "static/media/img-qrcode.bb7ab266.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/wechatShare/components/images/img-qrcode.png
// module id = 891
// module chunks = 0